
import { Action, Component, namespace, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'

const wallCollectionsStore = namespace('wallCollections')

@Component({
  components: {
    OzIcon,
  },
})
export default class SurfaceNavBookmarkMenuRow extends Vue {
  @Action bookmarkWallAndNotify
  @Action openEditBookmarksDialog

  @wallCollectionsStore.Getter isActiveWallBookmarked
}
